<template>
  <path d="M.4.508 23.592 15.5.4 30.492z" fill="currentColor" fill-rule="evenodd"/>
</template>
